import React from "react";
import { Box, Button, Grid, LinearProgress } from "@material-ui/core";
import TextFieldHelper from "../../UI/FormHelper/TextFieldHelper";
import FieldDatePicker from "../../Form/FieldDatePicker";
import UserAutoComplete from "../../Form/UserAutoComplete";
import Wrapper from "../../../hoc/Wrapper/Wrapper";

const DebitCreditAddFormFields = (props) => {
  const {
    values,
    touched,
    handleChange,
    isValid,
    setFieldTouched,
    setFieldValue,
    handleClose,
    handleSubmit,
    errors,
  } = props;

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                title={"کاربر"}
                fieldName={"user_id"}
                setFieldValue={setFieldValue}
                fieldNameShow={"user_fullname"}
                value={values.user_fullname}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper title={"بابت"} fieldName={"about"} {...props} />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"مبلغ"}
                fieldName={"amount"}
                isNumber={true}
                {...props}
              />
            </Box>
          </Grid>

          {/*<Grid item xs={12} md={6}>*/}
          {/*    <Box p={1}>*/}
          {/*        <TextFieldHelper*/}
          {/*            title={"مانده"}*/}
          {/*            fieldName={"remained"}*/}
          {/*            isNumber={true}*/}
          {/*            {...props}*/}
          {/*        />*/}
          {/*    </Box>*/}
          {/*</Grid>*/}

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDatePicker label={"تاریخ "} fieldName={"date"} {...props} />
            </Box>
          </Grid>

          {/*<Grid item xs={12} md={6}>*/}
          {/*    <Box p={1}>*/}
          {/*        <FieldDatePicker*/}
          {/*            label={"تاریخ تسویه نهایی"}*/}
          {/*            fieldName={"cleared_at"}*/}
          {/*            {...props}*/}
          {/*        />*/}
          {/*    </Box>*/}
          {/*</Grid>*/}

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                type={"select"}
                select={true}
                title={"نوع"}
                fieldName={"type"}
                {...props}
                options={[
                  {
                    value: "debt",
                    label: "بدهکاری",
                  },
                  {
                    value: "credit",
                    label: "بستانکاری",
                  },
                ]}
              />
            </Box>
          </Grid>

          {/*<Grid item xs={12} md={6}>*/}
          {/*    <Box p={1}>*/}
          {/*        <TextFieldHelper*/}
          {/*            type={'select'}*/}
          {/*            select={true}*/}
          {/*            title={"وضعیت"}*/}
          {/*            fieldName={"status"}*/}
          {/*            {...props}*/}
          {/*            options={[*/}
          {/*                {*/}
          {/*                    value : 'cleared',*/}
          {/*                    label  : 'تسویه شده'*/}
          {/*                },*/}
          {/*                {*/}
          {/*                    value : 'not_cleared',*/}
          {/*                    label  : 'تسویه نشده'*/}
          {/*                },*/}
          {/*                {*/}
          {/*                    value : 'remained',*/}
          {/*                    label  : 'مانده'*/}
          {/*                }*/}
          {/*            ]}*/}
          {/*        />*/}
          {/*    </Box>*/}
          {/*</Grid>*/}

          <Grid item xs={12} md={12}>
            <Box p={1}>
              <TextFieldHelper
                title={"توضیحات"}
                fieldName={"description"}
                multiline={true}
                rows={5}
                {...props}
              />
            </Box>
          </Grid>

          {/*{props.isEdit ? <Wrapper>*/}

          {/*    <Grid item xs={12} md={6}>*/}
          {/*        <Box p={1}>*/}
          {/*            <TextFieldHelper*/}
          {/*                title={"تاریخ ویرایش"}*/}
          {/*                fieldName={"updated_at"}*/}
          {/*                {...props}*/}
          {/*                disabled={true}*/}

          {/*            />*/}
          {/*        </Box>*/}
          {/*    </Grid>*/}
          {/*    <Grid item xs={12} md={6}>*/}
          {/*        <Box p={1}>*/}
          {/*            <TextFieldHelper*/}
          {/*                title={"تاریخ ثبت"}*/}
          {/*                fieldName={"created_at"}*/}
          {/*                disabled={true}*/}
          {/*                {...props}*/}
          {/*            />*/}
          {/*        </Box>*/}
          {/*    </Grid>*/}
          {/*</Wrapper> : null}*/}
        </Grid>

        <Box mt={2}>
          {props.loading ? (
            <Wrapper>
              <Button
                fullwidth={true}
                size={"large"}
                disabled={true}
                color={"default"}
              >
                در حال ارسال
              </Button>
              <LinearProgress />
            </Wrapper>
          ) : (
            <Button
              variant={"contained"}
              type="submit"
              size={"large"}
              fullWidth={true}
              color={"primary"}
            >
              {props.isEdit ? "ثبت ویرایش" : "افزودن بدهی"}
            </Button>
          )}
        </Box>
      </form>
    </div>
  );
};

export default DebitCreditAddFormFields;
